import * as Types from "../actions/actionTypes";

const initialState = {
  isAuthenticated: !!localStorage.getItem(process.env.REACT_APP_TOKEN_KEY),
  loginErrors: {},
  logoutErrors: {},
  resetPasswordErrors: {},
  loading: false,
  passwordResetEmailSent: false,
  passwordResetted: false,
  user: {
    // company: {
    //   templates: [],
    //   data_sources: [],
    // },
    // countries: [],
  },
  isResetEmailSent: false,
  isForgotPOpened: false,
  isForgotPasswordFailed: false,
  changePassword: {
    errors: {},
    success: false,
  },
  updateProfile: {
    errors: {},
    success: false,
  },
  vendorRegistration: {
    loading: false,
    data: {},
    errors: {},
    success: null,
  },
  userRegistration: {
    data: {},
    errors: {},
  },
};

function authReducer(state = initialState, action) {
  switch (action.type) {
    case Types.REGISTRATION_SUCCESS: {
      return {
        ...state,
        userRegistration: {
          data: action.payload,
          errors: {},
        },
      };
    }
    case Types.REGISTRATION_FAILURE: {
      return {
        ...state,
        userRegistration: {
          data: {},
          errors: action.payload,
        },
      };
    }
    case Types.USER_LOGGED_IN: {
      return {
        ...state,
        loading: false,
        isAuthenticated: true,
        loginErrors: {},
        user: action.payload ? action.payload : { ...state.user },
      };
    }
    case Types.USER_LOGIN_ERROR: {
      return {
        ...state,
        loading: false,
        loginErrors: action.payload,
      };
    }
    case Types.AUTH_LOADING: {
      return {
        ...state,
        loading: true,
      };
    }
    case Types.USER_LOGGED_OUT: {
      return {
        ...state,
        loading: false,
        isAuthenticated: false,
      };
    }
    case Types.USER_LOGOUT_ERROR: {
      return {
        ...state,
        loading: false,
        logoutErrors: action.payload,
      };
    }
    case Types.USER_FORGOT_PASSWORD_SUCCESS: {
      return {
        ...state,
        loading: false,
        isResetEmailSent: action.payload,
      };
    }
    case Types.TOGGLE_FORGOT_PASSWORD: {
      return {
        ...state,
        isForgotPOpened: action.payload,
      };
    }
    case Types.FORGOT_PASSWORD_FAIL: {
      return {
        ...state,
        isForgotPasswordFailed: action.payload,
      };
    }
    case Types.RESET_PASSWORD_ERROR: {
      return {
        ...state,
        loading: false,
        resetPasswordErrors: action.payload,
        passwordResetted: false,
      };
    }
    case Types.RESET_PASSWORD_STATUS: {
      return {
        ...state,
        loading: false,
        passwordResetted: action.payload,
        resetPasswordErrors: {},
      };
    }
    case Types.CHANGE_PASSWORD_ERRORS: {
      return {
        ...state,
        loading: false,
        changePassword: {
          success: false,
          errors: action.payload,
        },
      };
    }
    case Types.PASSWORD_CHANGED: {
      return {
        ...state,
        loading: false,
        changePassword: {
          success: true,
          errors: {},
        },
      };
    }
    case Types.PROFILE_UPDATE_ERRORS: {
      return {
        ...state,
        loading: false,
        updateProfile: {
          success: false,
          errors: action.payload,
        },
      };
    }
    case Types.PROFILE_UPDATED: {
      return {
        ...state,
        loading: false,
        user: action.payload,
        updateProfile: {
          success: true,
          errors: {},
        },
      };
    }
    case Types.FCM_UPPDATED: {
      return {
        ...state,
        user: {
          ...state.user,
          fcm_token: action.payload,
        },
      };
    }
    case Types.VENDOR_REGISTRATION_LOADING: {
      return {
        ...state,
        vendorRegistration: {
          loading: true,
          success: false,
          data: {},
          errors: {},
        },
      };
    }
    case Types.VENDOR_REGISTRATION_SUCCESS: {
      return {
        ...state,
        vendorRegistration: {
          loading: false,
          success: true,
          data: action.payload,
          errors: {},
        },
      };
    }
    case Types.VENDOR_REGISTRATION_FAILURE: {
      return {
        ...state,
        vendorRegistration: {
          loading: false,
          success: false,
          data: action.data,
          errors: action.payload,
        },
      };
    }
    default:
      return state;
  }
}

export default authReducer;
